import { useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Search, Trash2 } from "lucide-react";
import { api, money, shortDate } from "@/util";

export default function Tours({ tours, user, onNew, onChanged }) {
  const [query, setQuery] = useState("");
  const [status, setStatus] = useState("Tümü");
  const isManager = user?.role === "Yönetici";

  const filtered = tours.filter((tour) =>
    `${tour.name} ${tour.destination}`.toLocaleLowerCase("tr-TR").includes(query.toLocaleLowerCase("tr-TR")) &&
    (status === "Tümü" || tour.status === status)
  );

  const remove = async (e, id) => {
    e.preventDefault();
    e.stopPropagation();
    if (!isManager) return;
    if (!window.confirm("Bu tur silinsin mi?")) return;
    await api.delete(`/tours/${id}`);
    onChanged?.();
  };

  return (
    <section className="page-section">
      <div className="section-header">
        <div>
          <span className="eyebrow">OPERASYON MERKEZİ</span>
          <h2>Turların, tek bakışta.</h2>
          <p>Planlanan tüm operasyonlarını ve doluluklarını buradan yönet.</p>
        </div>
        <button className="primary-button" onClick={() => onNew("tour")} data-testid="tours-add-button">
          <Plus size={17} /> Yeni tur
        </button>
      </div>
      <div className="filter-row">
        <div className="search">
          <Search size={16} />
          <input value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Tur ara..." data-testid="tour-search-input" />
        </div>
        <select className="filter-button" value={status} onChange={(e) => setStatus(e.target.value)} data-testid="tour-status-filter">
          <option value="Tümü">Tüm durumlar</option>
          <option value="Yaklaşıyor">Yaklaşıyor</option>
          <option value="Onaylandı">Onaylandı</option>
          <option value="Beklemede">Beklemede</option>
          <option value="Tamamlandı">Tamamlandı</option>
        </select>
      </div>
      {filtered.length ? (
        <div className="tour-cards">
          {filtered.map((tour, index) => {
            const marj = (tour.revenue || 0) - (tour.cost || 0);
            return (
              <Link to={`/turlar/${tour.id}`} className="tour-card tour-card-link" key={tour.id} data-testid={`tour-card-${index}`}>
                <div className="tour-card-top">
                  <span className={`status ${tour.status === "Yaklaşıyor" ? "warning" : tour.status === "Beklemede" ? "pending" : "success"}`}>
                    {tour.status}
                  </span>
                  {isManager && (
                    <button className="more-button danger" onClick={(e) => remove(e, tour.id)} data-testid={`tour-delete-${index}`} title="Sil">
                      <Trash2 size={14} />
                    </button>
                  )}
                </div>
                <h3>{tour.name}</h3>
                <p>
                  <span>{tour.destination || "—"}</span>
                  <span>{shortDate(tour.start_date)} – {shortDate(tour.end_date)}</span>
                  {tour.operator && <span className="muted">· {tour.operator}</span>}
                </p>
                <div className="tour-card-footer">
                  <div>
                    <small>DOLULUK</small>
                    <b>{tour.sold} <span>/ {tour.capacity} kişi</span></b>
                    <div className="progress"><i style={{ width: `${(tour.sold / Math.max(tour.capacity, 1)) * 100}%` }} /></div>
                  </div>
                  <div className="tour-revenue">
                    <small>GELİR / MARJ</small>
                    <b>{money(tour.revenue)}</b>
                    <small className={marj >= 0 ? "positive" : "negative"}>
                      {marj >= 0 ? "+" : ""}{money(marj)}
                    </small>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      ) : (
        <div className="empty-page search-empty">
          <div className="empty-icon"><Search size={22} /></div>
          <h2>Tur bulunamadı</h2>
          <p>Arama veya durum filtresini değiştirerek tekrar dene.</p>
        </div>
      )}
    </section>
  );
}
